/*
import './navbar.css';
import React  from 'react';

import logoimg from '../img/logo.png';


function NavBar() {
  return (
    <>
        <nav className="navbar bg-white fixed-top">
          <div className="container mt-3 pb-3">
            <div className="logo">
              <img src={logoimg} alt="تكويب تصميم وتطوير مواقع الويب" />
            </div>
            <div>
              <button type="button" className="btn callbtn">
                إتصل بنا
                <FontAwesomeIcon icon={faPhone} className='me-2'/>
              </button>
              <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-expanded="false" aria-label="Toggle navigation">
                <FontAwesomeIcon icon={faBars}  />
              </button>
            </div>
            <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
              <div className="offcanvas-header d-flex justify-content-between">
                <div className="logo">
                  <img src={logoimg} alt="تكويب تصميم وتطوير مواقع الويب" />
                </div>
                <div>
                  <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
              </div>
              <div className="offcanvas-body">
                <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                  <li className="nav-item">
                    <a className="nav-link " aria-current="page" href="#heroid">البداية</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#whatid">ماذا يعني صفحة هبوط ؟</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#featuresid">مزايا صفحات الهبوط</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#basiccomponentsid">المكونات الأساسية لصفحات الهبوط</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#importanceid">أهمية صفحة الهبوط</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">لماذا تختارنا !</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">كيف نعمل؟</a>
                  </li>
                </ul>
                <div className="d-flex mt-3 me-2">
                  <button type="button" className="btn callbtn w-100">
                    إتصل بنا
                    <FontAwesomeIcon icon={faPhone} className='me-2'/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </nav>
    </>
  );
}

export default NavBar;
*/
import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import './navbar.css'
import logoimg from '../img/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faPhone } from '@fortawesome/free-solid-svg-icons';


export default function AnchorTemporaryDrawer() {
  const [state, setState] = React.useState({
    right: false,
  });

  const makeCall = () => { window.location.href = 'tel:0568300288'; };

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleListItemClick = (event, targetId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const offset = -50; // هنا تضيف -50 بكسل
      const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset + offset;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 270 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
      className= 'listnav'
    >
      <List>
      <img src={logoimg} alt="logo" className='logoimg m--5' />
        {[
          { text: 'البداية', target: 'heroid' },
          { text: 'ماهي المواقع الإلكترونية ', target: 'whatid' },
          { text: 'أنواع المواقع الإلكترونية', target: 'typesofwebsitesid' },
          { text: 'مزايا المواقع الإلكترونية', target: 'featuresid' },
          { text: 'مكونات المواقع الإلكترونية', target: 'basiccomponentsid' },
          { text: 'لماذا المواقع الإلكترونية', target: 'importanceid' },
          { text: 'أمثلة على المواقع الإلكترونية', target: 'exampleid' },
          { text: 'أهم المقالات', target: 'cardlistid' },
          { text: 'أسئلة العملاء', target: 'faqid' },
          { text: 'إطلب الخدمة الأن', target: 'contactid' },
        ].map((item, index) => (
          <ListItem key={item.text} disablePadding  className=''>
            <ListItemButton onClick={(event) => handleListItemClick(event, item.target)}>
              <ListItemText primary={item.text} className='linav'/>
            </ListItemButton>
          </ListItem>
        ))}
         <button type="button" className="btn callbtn w-100 mt-4" onClick={makeCall}>
                    إتصل بنا
                    <FontAwesomeIcon icon={faPhone} className='me-2'/>
          </button>
      </List>
    </Box>
  );
  return (
    <div className='sticky-navbar' id='navid'>
   <div className="container">
   <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <img src={logoimg} alt="تكويب لتصميم مواقع الويب" className='logoimg me-4'/>
      <div>
      <button type="button" className="btn callbtn" onClick={makeCall}>
         إتصل بنا 
         <FontAwesomeIcon icon={faPhone} className="me-2" />
         </button>
      <Button onClick={toggleDrawer('right', true)}>
      <FontAwesomeIcon icon={faBars}  className='bar'/>
      </Button>
      </div>
      
    </div>
    {['right'].map((anchor) => (
      <React.Fragment key={anchor}>
        <Drawer
          anchor={anchor === 'center' ? 'right' : anchor}
          open={state[anchor]}
          onClose={toggleDrawer(anchor, false)}
        >
          {list(anchor)}
        </Drawer>
      </React.Fragment>
    ))}
   </div>
  </div>
  
  );
}
